import {
  APIProvider,
  Map,
  MapCameraChangedEvent,
  useMap,
} from "@vis.gl/react-google-maps";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Clusters } from "./ClusteredMarkers";
import {
  setCurrentRoute,
  setMapCenter,
  setMapZoom,
} from "../../store/reducers/listingReducer";
import { debounce } from "lodash";
import { DrawArea } from "./DrawArea";
import { Polygon } from "./Polygon";
import { baseQueryAPI } from "../../services/baseQuery";
import { Polyline } from "./PolyLine";
import { ClusterMarkers } from "./ClusterMarkers";

export const GoogleMaps = () => {
  const listings = useSelector((state: any) => state.listingReducer.listings);
  const filterValues = useSelector(
    (state: any) => state.listingReducer.filterValues
  );
  const logged = useSelector((state: any) => state.listingReducer.logged);
  const currentRoute = useSelector(
    (state: any) => state.listingReducer.currentRoute
  );
  const userData = useSelector((state: any) => state.listingReducer.userData);

  const { data: teamArea, refetch: reFetchTeamArea } =
    baseQueryAPI.useTeamAreasQuery("");

  const { data: myArea } = baseQueryAPI.useAreaQuery("");

  const [homeLocation, setHomeLocation] = useState<any>({
    lat: 37.09024,
    lng: -95.712891,
  });

  const FilterWorker = useMemo(
    () =>
      new Worker(new URL("../../workers/listingFilter.ts", import.meta.url)),
    []
  );

  const [selectedArea, setSelectedArea] = useState("");
  const [printPath, setPrintPath] = useState([]);
  const [printProperties, setPrintProperties] = useState([]);
  const [isRouteEdit, setIsRouteEdit] = useState(false);
  const [isViewRoute, setIsViewRoute] = useState(false);
  const [editRoute, setEditRoute] = useState(null);

  const [filterListing, setFilterListing] = useState([]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setHomeLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });

        dispatch(
          setMapCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          })
        );
      });
    } else {
      console.log("could not geocode");
    }
  }, []);

  useEffect(() => {
    console.log("currentRoute", currentRoute);
    if (currentRoute) {
      setPrintPath(JSON.parse(currentRoute.path));
      setPrintProperties(JSON.parse(currentRoute.properties));
      setIsRouteEdit(true);
      setIsViewRoute(true);
      setEditRoute(currentRoute);
    } else {
      setIsRouteEdit(false);
      setIsViewRoute(false);
      setPrintPath([]);
      setPrintProperties([]);
      setEditRoute(null);
    }
  }, [currentRoute]);

  const dispatch = useDispatch();

  useEffect(() => {
    // const worker = new FilterWorker();

    console.log("sending message to worker");
    FilterWorker.postMessage({ listings, filterValues });

    FilterWorker.onmessage = (event: MessageEvent) => {
      setFilterListing(event.data);
    };

    FilterWorker.onerror = (error: ErrorEvent) => {
      console.error("Worker error:", error);
    };
  }, [FilterWorker, filterValues, listings]);

  const handleCenterChange = useCallback(
    (e: MapCameraChangedEvent) => {
      if (e.detail.center) {
        dispatch(
          setMapCenter({
            lat: e.detail.center.lat,
            lng: e.detail.center.lng,
          })
        );
      }
    },
    [dispatch]
  );

  const handleZoomChange = useCallback(
    (e: MapCameraChangedEvent) => {
      if (e.detail) {
        dispatch(setMapZoom(e.detail.zoom));
      }
    },
    [dispatch]
  );

  const onAddToPrint = useCallback(
    (listing: any) => {
      if (!logged) {
        return;
      }
      const position = {
        lat: parseFloat(listing.latitude),
        lng: parseFloat(listing.longitude),
      };
      setPrintPath((prevPrintPath) => {
        let newState: any;
        const index = prevPrintPath.findIndex(
          (itm: any) => itm.lat === position.lat && itm.lng === position.lng
        );
        if (index !== -1) {
          newState = prevPrintPath
            .slice(0, index)
            .concat(prevPrintPath.slice(index + 1));
        } else newState = [...prevPrintPath, position];
        return newState;
      });

      setPrintProperties((prevState) => {
        let newPropertyState: any;
        const index = prevState.findIndex(
          (itm: any) => itm === listing.listing_unique_id
        );
        if (index !== -1) {
          newPropertyState = prevState
            .slice(0, index)
            .concat(prevState.slice(index + 1));
        } else {
          newPropertyState = [...prevState, listing.listing_unique_id];
        }

        return newPropertyState;
      });
    },
    [printPath, printProperties]
  );

  return (
    <APIProvider apiKey="AIzaSyCclBCu30QD5vsNQKwg8PKrn2EofxY6YP4">
      <Map
        mapId="4e7937fed3430624"
        defaultZoom={13}
        defaultCenter={homeLocation}
        style={{ width: "100%", height: "100%" }}
        onCenterChanged={debounce(handleCenterChange, 500)}
        onZoomChanged={debounce(handleZoomChange, 500)}
      >
        {filterListing && (
          <ClusterMarkers
            onAddToPrint={onAddToPrint}
            listing={filterListing}
            printPath={printProperties}
          />
        )}

        {!selectedArea && printPath.length <= 1 && userData?.team_owner && (
          <DrawArea refetchArea={reFetchTeamArea} />
        )}

        {teamArea?.data?.map((area: any) => {
          // Calculate the center of the polygon
          const coordinates = JSON.parse(area.area_cordinates);
          let bounds = new window.google.maps.LatLngBounds();
          coordinates.forEach(function (coord: any) {
            bounds.extend(coord);
          });
          const center = bounds.getCenter();

          return (
            <div key={area.area_public_id}>
              <Polygon
                area={area}
                selected={selectedArea}
                setSelected={setSelectedArea}
                refetchArea={reFetchTeamArea}
                teamOwner={userData?.team_owner}
              />
            </div>
          );
        })}

        {myArea?.data?.map((area: any) => {
          // Calculate the center of the polygon
          const coordinates = JSON.parse(area.area_cordinates);
          let bounds = new window.google.maps.LatLngBounds();
          coordinates.forEach(function (coord: any) {
            bounds.extend(coord);
          });
          const center = bounds.getCenter();

          return (
            <div key={area.area_public_id}>
              <Polygon
                area={area}
                selected={selectedArea}
                setSelected={setSelectedArea}
                refetchArea={reFetchTeamArea}
                teamOwner={userData?.team_owner}
              />
            </div>
          );
        })}

        {printPath.length > 1 && (
          <Polyline
            path={printPath}
            properties={printProperties}
            onClose={() => {
              setPrintPath([]);
              setPrintProperties([]);
              setIsRouteEdit(false);
              setIsViewRoute(false);
              dispatch(setCurrentRoute(null));
            }}
            isEdit={isRouteEdit}
            isView={isViewRoute}
            setIsView={setIsViewRoute}
            edit={editRoute}
          />
        )}
      </Map>
    </APIProvider>
  );
};

const HidePOI = () => {
  const map = useMap();
  useEffect(() => {
    if (!map) return;
    map.setOptions({
      styles: [{ featureType: "poi", stylers: [{ visibility: "off" }] }],
    });
  }, [map]);

  return null;
};
